import TryDemo from 'modules/auth/pages/TryDemo';
import Login from 'modules/auth/pages/Login';
import LoginPWC from 'modules/auth/pages/LoginPWC';
import LoginPLD from 'modules/auth/pages/LoginPLD';

export const unprotectedRoutes = [
  {
    id: 'demo',
    path: '/demo',
    component: TryDemo,
  },
  {
    id: 'login',
    path: '/login',
    component: Login,
  },
  {
    id: 'pwc-login',
    path: '/pwc-login',
    component: LoginPWC,
  },
  {
    id: 'pld-login',
    path: '/pld-login',
    component: LoginPLD,
  },
];
